// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zqslsjvhqtkiuwvqvwwl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpxc2xzanZocXRraXV3dnF2d3dsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk4NTAyMzMsImV4cCI6MjA2NTQyNjIzM30.GnUT3GhvAEjYRhR7rSsip6rhJunurcn3LpH5tUr_a50";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});